/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { PROP_NAMES } from '@zcode/mixpanel'
import type { Origin } from '@zcode/nr-utils'
import * as Optimizely from '@zcode/nr/es/shared/packages/optimizely-middleware'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import type { Dispatch } from 'redux'
import { trackShortTermExternalLinkClick } from '../../../components/detail/helpers/trackShortTermExternalLinkClick'
import { SHORT_TERM_CLICK_OUT } from '../../../packages/optimizely/constants/events'
import { mixpanelShortTermClickOut } from '../../mixpanel/thunks/mixpanelShortTermClickOut'
import { selectVrboTotalPriceWithPropertyFees } from '../../shortTermAvailability/selectors/vrbo'
import { trackShortTermClickOut } from '../../traktor/thunks/trackShortTermClickOut'
import type { GetState } from '../../types'

interface Props {
  dates?: readonly Date[]
  entity: MaybeEmpty<Listable> | MaybeEmptyProperty
  extraPayload?: { [PROP_NAMES.BUTTON_CLICKED]: string }
  origin: 'booknow' | Origin | 'pin'
}

export const trackShortTermClickout =
  ({ dates, entity, extraPayload, origin }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const totalPriceIncludingTaxes = selectVrboTotalPriceWithPropertyFees(state) || null

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    dispatch(Optimizely.track({ eventKey: SHORT_TERM_CLICK_OUT }))
    dispatch(mixpanelShortTermClickOut({ entity, extraPayload, origin }))
    dispatch(
      trackShortTermClickOut({
        entity,
        additionalProps: { totalPriceIncludingTaxes },
        dates,
      })
    )
    dispatch(trackShortTermExternalLinkClick(entity))
  }
